var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivateicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3059_2778",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3059_2778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5416 9.1665L13.2083 10.8332H14.5833C14.9305 10.8332 15.2257 10.7116 15.4687 10.4686C15.7118 10.2255 15.8333 9.93039 15.8333 9.58317V7.08317C15.8333 6.73595 15.7118 6.44081 15.4687 6.19775C15.2257 5.9547 14.9305 5.83317 14.5833 5.83317H10.4166C10.1111 5.83317 9.84718 5.93039 9.62496 6.12484C9.40274 6.31928 9.2569 6.55539 9.18746 6.83317L9.87496 7.49984H14.1666V9.1665H11.5416ZM18.1458 15.7707L16.6666 14.2915V4.99984H7.37496L5.70829 3.33317H16.6666C17.125 3.33317 17.5173 3.49636 17.8437 3.82275C18.1701 4.14914 18.3333 4.5415 18.3333 4.99984V14.9998C18.3333 15.1387 18.3194 15.2741 18.2916 15.4061C18.2638 15.538 18.2152 15.6596 18.1458 15.7707ZM17.0416 19.4165L14.2916 16.6665H3.33329C2.87496 16.6665 2.4826 16.5033 2.15621 16.1769C1.82982 15.8505 1.66663 15.4582 1.66663 14.9998V4.99984C1.66663 4.5415 1.82982 4.14914 2.15621 3.82275C2.4826 3.49636 2.87496 3.33317 3.33329 3.33317L4.99996 4.99984H3.33329V14.9998H12.625L0.541626 2.9165L1.72913 1.729L18.2291 18.229L17.0416 19.4165Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateicon);
export default __webpack_public_path__ + "static/media/deactivateicon.bcac2ffe8142f4a1377153d43edf65c0.svg";
export { ForwardRef as ReactComponent };